import { bouncy } from 'ldrs';

bouncy.register();

type Props = {
  size?: number;
  speed?: number;
};

export const Loading = ({ size = 45, speed = 1.75 }: Props) => {
  return <l-bouncy size={size} speed={speed} color="currentColor"></l-bouncy>;
};
